var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function copyToClipboard(text) {
    // 创建一个隐藏的输入元素
    var input = document.createElement('input');
    // 设置输入元素的值为要复制的文本
    input.value = text;
    // 将输入元素添加到文档中
    document.body.appendChild(input);
    // 选择输入元素的内容
    input.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除输入元素
    document.body.removeChild(input);
}
// export function _T(txt: string) {
//     const lan = getArgFromUrl('language')
//     const l: any = lan === 'en' ? langEn : lang
//     return l[txt]
// }
export function sprintf(txt, obj) {
    var result = txt;
    Object.keys(obj).forEach(function (key) {
        result = result.replace("{".concat(key, "}"), obj[key]);
    });
    return result;
}
export function getArgFromUrl(name) {
    var url = window.location.href;
    // 检查URL中是否包含哈希路由
    if (url.includes('#/')) {
        // 处理哈希路由后的查询参数
        var hashPart = url.split('#/')[1];
        var hashPart2 = url.split('#/')[0];
        if (hashPart && hashPart.includes('?')) {
            var queryString = hashPart.split('?')[1];
            var params = new URLSearchParams(queryString);
            return params.get(name);
        }
        if (hashPart2 && hashPart2.includes('?')) {
            var queryString = hashPart2.split('?')[1];
            var params = new URLSearchParams(queryString);
            return params.get(name);
        }
        return null;
    }
    else {
        // 处理常规查询参数
        var urlObj = new URL(url);
        var params = new URLSearchParams(urlObj.search);
        return params.get(name);
    }
}
export function formaTimeForTsToH(time) {
    return (time / 1000 / 60 / 60).toFixed(2) + 'H';
}
export function formatScore(num) {
    if (num > 999999999) {
        return '999.9M+';
    }
    if (num >= 1000000) {
        return (Math.floor(num / 100000) / 10).toFixed(1) + 'M';
    }
    if (num >= 1000) {
        return (Math.floor(num / 100) / 10).toFixed(1) + 'k';
    }
    return String(num);
}
export function formatScoreComma(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function getStatusBarHeight() {
    return new Promise(function (resolve) {
        window.addEventListener('fromFlutter', function (event) {
            var _a = event.detail, method = _a.method, height = _a.height;
            resolve(height);
        });
        if (window.toFlutter) {
            window.toFlutter.postMessage(JSON.stringify({ method: 'getStatusBarHeight' }));
        }
        setTimeout(function () {
            resolve(0);
        }, 100);
    });
}
export function isNumber(value) {
    var regex = /^[+-]?\d+(\.\d+)?$/;
    return regex.test(value);
}
export function setViewport() {
    function setScale() {
        var width = document.documentElement.clientWidth || window.innerWidth;
        var scale = Math.ceil((width / 375) * 100) / 100;
        var viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta) {
            viewportMeta.setAttribute('content', "width=375, initial-scale=".concat(scale, ", maximum-scale=").concat(scale, ", user-scalable=no"));
        }
        else {
            var meta = document.createElement('meta');
            meta.name = 'viewport';
            meta.content = "width=375, initial-scale=".concat(scale, ", maximum-scale=").concat(scale, ", user-scalable=no");
            document.head.appendChild(meta);
        }
    }
    window.addEventListener('load', function () {
        setScale();
    });
}
export function getPlatform() {
    var platform = getArgFromUrl('platform');
    var ua = navigator.userAgent, isWindowsPhone = /(?:Windows Phone)/.test(ua), isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, isAndroid = /(?:Android)/.test(ua), isFireFox = /(?:Firefox)/.test(ua), isChrome = /(?:Chrome|CriOS)/.test(ua), isTablet = /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)), isIPhone = (/(?:iPhone)/.test(ua) && !isTablet) || platform === 'iOS', isPc = !isIPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isIPhone: isIPhone,
        isAndroid: isAndroid,
        isPc: isPc,
        isChrome: isChrome,
    };
}
export function calculateWindow(num) {
    var platform = getPlatform();
    if (platform.isPc && !platform.isTablet) {
        return;
    }
    var width = window.screen.width;
    var height = Math.min(window.screen.height, window.innerHeight);
    if (height < 5) {
        setTimeout(function () {
            calculateWindow(num);
        }, 16);
        return;
    }
    var scale = Number((width / num).toFixed(3));
    var meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = "width=device-width,initial-scale=".concat(scale, ",user-scalable=no,maximum-scale=").concat(scale, ",minimum-scale=").concat(scale, ",viewport-fit=cover");
    document.documentElement.style.width = "".concat(num, "px");
    if (platform.isIPhone) {
        document.documentElement.style.height = '100vh';
    }
    else {
        document.documentElement.style.height = "".concat(window.innerHeight, "px");
    }
    // #
}
export function jumpToUserCard(uid) {
    console.log('11', uid);
    if (!uid) {
        return;
    }
    if (window.toFlutter) {
        window.toFlutter.postMessage(JSON.stringify({ method: 'openProfile', userId: uid }));
    }
}
export function formatMonth(m) {
    var year = m.getFullYear();
    var month = m.getMonth() + 1;
    return "".concat(year).concat(month < 10 ? '0' + month : month);
}
var flutterMessageTimer = null;
var postMessageToFlutter = function (reward) {
    if (flutterMessageTimer) {
        clearTimeout(flutterMessageTimer);
    }
    flutterMessageTimer = setTimeout(function () {
        try {
            if (window.toFlutter) {
                window.toFlutter.postMessage(JSON.stringify(__assign({ method: 'preview' }, reward)));
            }
        }
        catch (error) {
            console.error(error);
        }
    }, 300);
};
export function previewReward(reward) {
    postMessageToFlutter(reward);
}
export var goBack = function () {
    if (window.history.length > 1) {
        window.history.back();
    }
    else {
        window.toFlutter.postMessage(JSON.stringify({
            method: 'closeWebView',
        }));
    }
};
// static Map<num,List<Color>> colorMap = {
//     1:[const Color(0xffFF603B)],
//     2:[const Color(0xff3BA3FF)],
//     3:[const Color(0xffFFA73B)],
//     4:[const Color(0xff3BFF90)],
//     5:[const Color(0xffC43BFF)],
//     6:[const Color(0xff3B75FF),const Color(0xff3BD8FF)],
//     7:[const Color(0xffFF3B90),const Color(0xffFFCE3B)],
//     8:[const Color(0xffFF0000),const Color(0xffFFCE3B)],
//   };
/**
 * 兼容 Vite 和 Webpack 的资源加载函数
 * @param path 资源路径
 * @param callerImportMeta 调用方的 import.meta（可选，用于Vite环境）
 * @returns 返回一个获取资源URL的函数
 */
export var getAssetUrl = function (path, callerImportMeta) {
    return function () {
        // 检测是否为 Vite 环境
        if (typeof import.meta !== 'undefined' && import.meta.url) {
            // 优先使用调用方传入的 import.meta
            var metaToUse = callerImportMeta || import.meta;
            return new URL(path, metaToUse.url).href;
        }
        else {
            // Webpack 环境
            return require(path);
        }
    };
};
export var getVipColor = function (level) {
    var color = {
        1: '#FF603B',
        2: '#3BA3FF',
        3: '#FFA73B',
        4: '#3BFF90',
        5: '#C43BFF',
        6: ['#3B75FF', '#3BD8FF'],
        7: ['#FF3B90', '#FFCE3B'],
        8: ['#FF0000', '#FFCE3B'],
    };
    if (level <= 0) {
        return {};
    }
    if (level <= 5) {
        return { color: color[level] };
    }
    else {
        return {
            background: "linear-gradient(to right, ".concat(color[level][0], ", ").concat(color[level][1], ")"),
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
        };
    }
};
